import { createLossLimits, fetchLossLimits } from "app/api/lossLimitsApi";
import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import LossLimits from "app/screens/RegisterScreen/components/LossLimits/LossLimits";
import { LossLimitsType } from "app/types/userType";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import LossLimitsText from "./components/LossLimitsText";
import UpdateLossLimits from "./components/UpdateLossLimits";

export const LossLimitsContainer = props => {
  const intl = useIntl();
  const [lossLimit, setLossLimit] = useState<LossLimitsType>(null);
  const [hasLossLimitError, sethasLossLimitError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formattedErrors, setFormattedErrors] = useState<string[]>([]);
  const [lossLimits, setLossLimits] = useState<LossLimitsType>(null);
  const [isCreateVisible, setIsCreateVisible] = useState<boolean>(false);
  const hasCheckedCreateVisible = useRef(false);

  const validateLossLimit = () => {
    if (hasLossLimitError) {
      const errorMessage = intl.formatMessage({
        id: "number-input-error-message",
        defaultMessage: "Please enter a valid number",
      });
      setErrorMessage(errorMessage);
      return false;
    } else if (
      !lossLimit ||
      (!lossLimit.lossLimitOneDay &&
        !lossLimit.lossLimitSevenDays &&
        !lossLimit.lossLimitThirtyDays)
    ) {
      const errorMessage = intl.formatMessage({
        id: "number-input-error-message",
        defaultMessage: "Please enter a valid number",
      });
      setErrorMessage(errorMessage);
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const createLossLimit = () => {
    if (!validateLossLimit()) {
      return;
    }
    createLossLimits(lossLimit)
      .then((resp: LossLimitsType) => {
        console.log("resp: ", resp);
        setLossLimits(prevLimits => ({ ...prevLimits, ...resp }));
        setSuccessMessage(
          intl.formatMessage({
            id: "loss-limits-activated",
            defaultMessage: "Limit Activated",
          })
        );
      })
      .catch(error => {
        console.log("error: ", error);
        setSuccessMessage("");
        const errors = error.response.data.errors;
        console.log("errors: ", errors);
        formatErrorsForDisplay(errors);
      });
  };
  const formatErrorsForDisplay = (errors: any[]) => {
    if (errors.length === 0) {
      return;
    }
    const formattedErrors: string[] = [];
    errors.forEach(error => {
      console.log("error: ", error);
      if (error.field && error.messages && error.messages.length > 0) {
        formattedErrors.push(`${error.field}: ${error.messages[0]}`);
      }
    });
    formattedErrors && setFormattedErrors(formattedErrors);
  };
  const getLossLimits = () => {
    fetchLossLimits()
      .then((resp: LossLimitsType) => {
        setLossLimits(resp);
      })
      .catch(error => {
        console.log("error: ", error);
      });
  };
  useEffect(() => {
    if (lossLimits && !hasCheckedCreateVisible.current) {
      checkAndSetCreateVisible();
      hasCheckedCreateVisible.current = true;
    }
  }, [lossLimits]);

  useEffect(() => {
    getLossLimits();
  }, []);

  const checkAndSetCreateVisible = () => {
    if (
      !lossLimits ||
      typeof lossLimits.lossLimitOneDay !== "number" ||
      typeof lossLimits.lossLimitSevenDays !== "number" ||
      typeof lossLimits.lossLimitThirtyDays !== "number"
    ) {
      setIsCreateVisible(true);
      return;
    }

    setIsCreateVisible(false);
  };
  const hasLimitSet = () => {
    if (!lossLimits) {
      return false;
    }
    return (
      lossLimits.lossLimitOneDay !== null ||
      lossLimits.lossLimitSevenDays !== null ||
      lossLimits.lossLimitThirtyDays !== null
    );
  };

  return (
    <div className="loss-limits-container">
      <div className="loss-limits-container__title">
        <h2>
          <FormattedMessage
            id="loss-limits-title"
            defaultMessage="Loss Limits"
          />
        </h2>
      </div>
      <div className="loss-limits-container__responsible-gaming__text">
        <FormattedMessage
          id="loss-limits-main-text"
          defaultMessage={
            "If you would like to set a maximum amount that you want to spend on 3et in a given timeframe, we offer you that control via loss limits. For more details refer to our "
          }
        />
        <Link
          to={
            SessionHelper.isAsianRouteAndSessionView()
              ? ROUTES.asianHelpAndLearningResponsibleGaming
              : ROUTES.helpAndLearningResponsibleGaming
          }
          className={`loss-limits-container__responsible-gaming__link`}
        >
          <FormattedMessage
            tagName="span"
            id="settings-responsible-gambling-link"
          />
        </Link>
      </div>

      {/* Show Edit if any limit is set */}
      {hasLimitSet() && (
        <UpdateLossLimits
          lossLimits={lossLimits}
          setLossLimits={setLossLimits}
          getLossLimits={getLossLimits}
        />
      )}

      {/* Dont show if all 3 limits are set */}
      {isCreateVisible && (
        <LossLimits
          onLimitChange={function (
            id: string,
            limit: LossLimitsType | null
          ): void {
            console.log("id: ", id);
            console.log("limit: ", limit);
            setLossLimit(limit);
          }}
          limit={lossLimit}
          handleErrorChange={function (id: string, value: boolean): void {
            sethasLossLimitError(value);
          }}
        />
      )}

      {isCreateVisible && (
        <>
          <div className="loss-limits__buttons">
            <button
              type="button"
              onClick={createLossLimit}
              className="loss-limits__buttons__submit-button"
            >
              <FormattedMessage
                id="loss-limits-activate"
                defaultMessage="Activate Loss Limit"
              />
            </button>
          </div>
          <div className="loss-limits__messages__error-message">
            <span>{errorMessage}</span>
            {formattedErrors.map(error => (
              <span>{error}</span>
            ))}
          </div>
          <div className="loss-limits__messages__success-message">
            <span>{successMessage}</span>
          </div>
        </>
      )}
      <LossLimitsText />
    </div>
  );
};

export default LossLimitsContainer;

// {
//   "errors": [
//       {
//           "field": "Daily loss limit",
//           "messages": [
//               "Amount must be less than current limit in order to activate a reduced limit."
//           ]
//       },
//       {
//           "field": "Weekly loss limit",
//           "messages": [
//               "Amount must be less than current limit in order to activate a reduced limit."
//           ]
//       },
//       {
//           "field": "Monthly loss limit",
//           "messages": [
//               "Amount must be less than current limit in order to activate a reduced limit."
//           ]
//       }
//   ]
// }
